import { DashboardModal } from '@uppy/react';
import React from 'react';
import { Uppy } from "@uppy/core";
import { connect } from 'react-redux';
import { IEditorState, closeImageUpload, doSetAttribute } from '../../redux';
import XHRUpload  from '@uppy/xhr-upload'
import { DynamoNode, ImageNode, ElementType } from 'dynamo-models';

import "@uppy/core/dist/style.min.css";
import "@uppy/dashboard/dist/style.min.css";

export interface IImageDashboardProps {
    isOpen: boolean;
    node?: DynamoNode;
    endpoint: string;

    doClose: () => void;
    getUrlSetter: (node: ImageNode) => (url: string) => void;
}

interface IImageDashboardState {
}

class ImageDashboard extends React.Component<IImageDashboardProps,IImageDashboardState> {
    constructor(props) {
        super(props);

        this.uppy = new Uppy(({
            allowMultipleUploads: true,
            restrictions: ({
                maxNumberOfFiles: 1,
                allowedFileTypes: [
                    "image/*",
                    ".jpg",
                    ".jpeg",
                    ".png",
                ],
            }),
        })).use(XHRUpload, {
            endpoint: props.endpoint,
        });

        this.uppy.on('upload-success', (file, response) => {
            const imageNode = this.props.node as ImageNode;
            this.props.getUrlSetter(imageNode)(response.body.url);
            this.uppy.reset();
            this.props.doClose();
        });
    }

    private uppy: Uppy;

    public componentWillUnmount() {
        this.props.doClose();
    }

    public render() {
        return (
            <DashboardModal
                open={this.props.isOpen}
                uppy={this.uppy}
                proudlyDisplayPoweredByUppy={false}
                closeModalOnClickOutside={true}
                showProgressDetails={true}
                onRequestClose={this.props.doClose}
            />
        );
    }
}

const stateToProps = (state: IEditorState) => ({
    isOpen: state.isUploadingImage,
    node: state.selectedNode,
});

const dispatchToProps = (dispatch) => ({
    doClose: () => dispatch(closeImageUpload()),
    getUrlSetter: (node: ImageNode) => ((currUrl?: string) => (url: string) => dispatch(doSetAttribute(() => node.url = url, () => node.url = currUrl)))(node.url),
});

export const ImageDashboardWidget = connect(stateToProps, dispatchToProps)(ImageDashboard);